import React, {useState} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import {MdDashboard, MdKeyboardArrowDown, MdKeyboardArrowUp} from "react-icons/md";
import {FaBorderTopLeft, FaCartShopping} from "react-icons/fa6";
import {Can} from "../../Can";

const OrderDropdownSidebar = ({thememode}) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const handleMainClick = () => {
        // Navigate to the default dashboard page
        navigate("/OrdersManagement");
    };

    const handleArrowClick = (e) => {
        e.stopPropagation(); // Prevent triggering the main click
        setIsOpen(!isOpen);
    };

    return (
        <div className="mb-1">
            <div
                className={`flex items-center justify-between p-3 pl-6 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300`}
                onClick={handleMainClick}
            >
                <div className={'flex items-center '}>
                    <FaBorderTopLeft className="mr-3"/>
                    <span className="flex-grow">Orders</span>
                </div>
                <div
                    className="p-1 hover:bg-gray-300 dark:hover:bg-gray-600 rounded"
                    onClick={handleArrowClick}
                >
                    {isOpen ? <MdKeyboardArrowUp/> : <MdKeyboardArrowDown/>}
                </div>
            </div>

            {isOpen && (
                <div>
                    <Can I="index" a="orders">
                    <NavLink
                        to="/Orders"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Orders</span>
                    </NavLink>
                    </Can>
                    <Can I="store" a="orders">
                    <NavLink
                        to="/Add-Order-By-Service"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Add Order</span>
                    </NavLink>
                    </Can>
                    <Can I="store" a="offerOrders">
                    <NavLink
                        to="/Add-Order-By-Offer"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Add Offer</span>
                    </NavLink>
                    </Can>
                    <Can I="store" a="customOffer">
                    <NavLink
                        to="/Add-Custom-Offer"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Add Custom Offer</span>
                    </NavLink>
                        <Can I="index" a="addBalanceRequests">
                            <NavLink
                                to="/AddBalanceRequests"
                                className={({isActive}) =>
                                    `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                        isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                                    }`
                                }
                            >
                                <span>Balance Requests</span>
                            </NavLink>
                        </Can>
                    </Can>
                    <Can I="index" a="orderRequests">
                    <NavLink
                        to="/OrderRequests"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Order Request</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="pins">
                    <NavLink
                        to="/Ads-Pin"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Pin List</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="banners">
                    <NavLink
                        to="/Ads-Main-Page"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Main Page List</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="topResults">
                    <NavLink
                        to="/Ads-Search-Result"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Search Result List</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="ticketAds">
                    <NavLink
                        to="/Ads-Ticket"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Ticket List</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="smmticket">
                    <NavLink
                        to="/Smm-ticket-campaings"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Ticket Campaigns</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="index">
                    <NavLink
                        to="/Transaction"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Transaction</span>
                    </NavLink>
                    </Can>
                    <Can I="index" a="orders">
                    <NavLink
                        to="/SmmDomainRequests"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Domain Requests</span>
                    </NavLink>
                    </Can>
                    <Can I="update" a="orders">
                    <NavLink
                        to="/UpdatedOrders"
                        className={({isActive}) =>
                            `flex items-center p-3 pl-12 text-lg font-medium text-darkPrimary dark:text-secondary hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer transition duration-300 ${
                                isActive ? "bg-gray-200 dark:bg-gray-700" : ""
                            }`
                        }
                    >
                        <span>Update Orders</span>
                    </NavLink>
                    </Can>
                </div>
            )}
        </div>
    );
};

export default OrderDropdownSidebar;